<template>
  <div class="login-container">
    <div class="login-content">
      <div class="title-container">
        <!-- <h3 class="title">高绩数据</h3> -->
        <img
          class="logo"
          src="https://static.gaojidata.com/gaojidata/logo/new-title-blue.svg"
          alt=""
        />
      </div>
      <div class="login-form">
        <ul class="tabs">
          <li
            :class="{ active: loginType == 'account' }"
            @click="changeType('account')"
          >
            账号登录
          </li>
          <li
            :class="{ active: loginType == 'message' }"
            @click="changeType('message')"
          >
            短信登录
          </li>
        </ul>
        <template v-if="loginType == 'account'">
          <el-form
            label-position="top"
            :model="loginForm"
            :rules="rules"
            ref="loginForm"
            label-width="100px"
            :key="'account'"
          >
            <el-form-item label="账号" prop="LoginName">
              <el-input
                v-model="loginForm.LoginName"
                placeholder="请输入账号"
                maxlength="80"
              >
              </el-input>
              <span
                slot="error"
                slot-scope="error"
                class="el-form-item__error"
                >{{ error.error }}</span
              >
            </el-form-item>
            <el-form-item label="密码" prop="Password">
              <el-input
                maxlength="32"
                :type="showPassword ? 'text' : 'password'"
                v-model="loginForm.Password"
                autocomplete="off"
                placeholder="请输入密码"
                @keyup.enter.native="submitForm('loginForm', 1)"
                ref="password"
              >
                <i
                  slot="suffix"
                  class="el-icon-invisible"
                  @click="showPwd"
                  :class="{ see: see }"
                ></i>
              </el-input>
              <span
                slot="error"
                slot-scope="error"
                class="el-form-item__error"
                >{{ error.error }}</span
              >
              <div class="config-box">
                <span
                  ><el-checkbox v-model="automaticallyLogin"
                    >自动登录</el-checkbox
                  ></span
                >
                <span
                  @click="goto_get_back_pd('get_back_password')"
                  class="get-back-pd"
                  >忘记密码?</span
                >
              </div>
            </el-form-item>
            <el-form-item>
              <el-button
                :loading="loading"
                type="button"
                @click="submitForm('loginForm', 1)"
                >登录</el-button
              >
            </el-form-item>
            <el-form-item>
              <div class="other-account">
                <div class="other-login">其他账号登录</div>
                <ul>
                  <li class="icon-wechat" @click="other_login('wechat')"></li>
                  <!--                  <li class="icon-qq" @click="other_login('qq')"></li>-->
                  <!--                  <li class="icon-sina" @click="other_login"></li>-->
                </ul>
              </div>
            </el-form-item>
          </el-form>
        </template>
        <template v-if="loginType == 'message'">
          <el-form
            label-position="top"
            :model="phoneLoginForm"
            :rules="phoneRules"
            ref="phoneLoginForm"
            label-width="100px"
            :key="'message'"
          >
            <el-form-item
              label="手机号码"
              prop="mobile"
              class="prefix-box no-tips"
              :error="errorMessage"
            >
              <el-input
                v-model.number="phoneLoginForm.mobile"
                placeholder="请输入手机号码"
                maxlength="11"
              >
                <i slot="prefix">＋86</i>
              </el-input>
              <span slot="error" slot-scope="error" class="el-form-item__error">
                <template v-if="error.error == '您输入的手机号码不存在'">
                  {{ error.error }},
                  <a
                    href="javascript:void(0)"
                    style="border-bottom: solid thin"
                    @click="goto_get_back_pd('phone_register')"
                    >去绑定</a
                  >
                </template>
                <template v-else>
                  {{ error.error }}
                </template>
              </span>
            </el-form-item>
            <div style="display: flex">
              <el-form-item
                label="验证码"
                prop="verifyCode"
                class="no-tips"
                style="width: calc(100% - 114px); margin-right: 10px"
              >
                <el-input
                  v-model="phoneLoginForm.verifyCode"
                  placeholder="请输入验证码"
                  maxlength="6"
                >
                </el-input>
                <span
                  slot="error"
                  slot-scope="error"
                  class="el-form-item__error"
                  >{{ error.error }}</span
                >
                <div class="config-box">
                  <span
                    ><el-checkbox v-model="automaticallyLogin"
                      >自动登录</el-checkbox
                    ></span
                  >
                  <!-- <span @click="goto_get_back_pd('phone_register')" class="get-back-pd">绑定手机号</span> -->
                </div>
              </el-form-item>
              <el-form-item :label="' '" class="get-check_code">
                <!--               -->
                <el-input
                  type="button"
                  :loading="loadingCode"
                  :value="value"
                  @click.native="get_authCode('phoneLoginForm')"
                  :class="{ wait: waiting }"
                ></el-input>
                <div class="config-box">
                  <span></span>
                  <!-- <span @click="goto_get_back_pd('phone_register')" class="get-back-pd">绑定手机号</span> -->
                </div>
              </el-form-item>
            </div>
            <el-form-item>
              <el-button
                :loading="loading"
                type="button"
                @click="submitForm('phoneLoginForm', 0)"
                >登录</el-button
              >
            </el-form-item>
            <el-form-item>
              <div class="other-account">
                <div class="other-login">其他账号登录</div>
                <ul>
                  <li class="icon-wechat" @click="other_login('wechat')"></li>
                  <!--                  <li class="icon-qq" @click="other_login('qq')"></li>-->
                  <!--                  <li class="icon-sina" @click="other_login"></li>-->
                </ul>
              </div>
            </el-form-item>
          </el-form>
        </template>
      </div>
      <div class="tips">
        建议使用<i class="el-icon-login-chrome" @click="down_chrome"></i
        >Chrome浏览器
      </div>

      <div id="qq_login_btn" ref="qq_login_btn"></div>
    </div>
    <div class="footer-content">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import { validUsername } from "@/utils/validate";
import Footer from "@/components/Footer/index.vue";
import Browser from "@/utils/browser";
import { sendSmsAuthCode, sendSmsAuthCodeNew } from "@/api/login";
import { mapMutations } from "vuex";
import {
  getTokenTime,
  setTokenTime,
  removeTokenTime,
  getStateOld,
  setStateOld,
  getToken,
  removeToken,
} from "@/utils/auth";
import { redirectUrl } from "@/setting";
import { setSessionStorage, getSessionStorage } from "@/utils/session";

export default {
  name: "Login",
  components: { Footer },
  data() {
    var validateNumber = (rule, value, callback) => {
      let numberReg = /^\d+$/;
      if (value !== "") {
        if (!numberReg.test(value)) {
          callback(new Error("请输入6位数字验证码"));
        } else {
          callback();
        }
      } else {
        callback(new Error("验证码不能为空"));
      }
    };
    var validatePhone = (rule, value, callback) => {
      const reg = /^[1][3-9][0-9]{9}$/;
      if (value == "" || value == undefined || value == null) {
        callback();
      } else {
        if (!reg.test(value) && value != "") {
          callback(new Error("请输入正确的手机号码"));
        } else {
          callback();
        }
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("验证码不能为空"));
      } else {
        callback();
      }
    };
    return {
      value: "获取验证码",
      errorMessage: null,
      waiting: false,
      see: false,
      loginType: this.$store.state.login.loginType || "account",
      showPassword: false,
      automaticallyLogin: false,
      loading: false,
      loadingCode: false,
      loginForm: {
        LoginName: "",
        Password: "",
      },
      phoneLoginForm: {
        mobile: "",
        verifyCode: "",
      },
      rules: {
        Password: [
          // { required: true, message: '密码不能为空', trigger: 'blur' },
          // { validator: validatePass, trigger: 'bulr' }
        ],
        LoginName: [
          // { required: true, message: '账号不能为空', trigger: 'blur' },
          // { validator: checkaccount, trigger: 'blur' }
        ],
      },
      phoneRules: {
        mobile: [
          { required: true, message: "手机号码不能为空", trigger: "blur" },
          { validator: validatePhone, trigger: "bulr" },
        ],
        authCode: [
          { required: true, message: "验证码不能为空", trigger: "blur" },
          { min: 6, max: 6, message: "请输入6位数字验证码", trigger: "blur" },
          { validator: validateNumber, trigger: "bulr" },
        ],
      },
      urlParams: {},
    };
  },
  mounted() {
    this.SET_LOGINTYPE("account");
    // var source=this.getQueryString("s")
    // var state=getStateOld()
    // if(source=="old"&&state==null){
    //  const h = this.$createElement;
    //  this.$message({
    //       message: h('p', null, [
    //         h('a', null, '本网址迁移至新网址：'),
    //         h('a', { style: 'color: #4556A5;text-decoration: underline;',attrs:{ "href": "http://www.gaojidata.com/#/login" } }, 'http://www.gaojidata.com/#/login'),
    //         h('a', null, '。请及时更新至收藏夹。')
    //       ]),
    //       type: 'warning',
    //       duration: 10000,
    //       onClose:function(){
    //         setStateOld()
    //       }
    //     });
    // }

    this.urlParams = this.queryParams(location.hash);
    console.log(this.urlParams);
    // QC.Login({
    //   btnId:"qq_login_btn"
    // })
  },
  methods: {
    ...mapMutations("login", ["SET_LOGINTYPE"]),
    showPwd() {
      this.showPassword = !this.showPassword;
      this.$nextTick(() => {
        this.see = !this.see;
        // this.$refs.password.focus();
      });
    },
    get_authCode(form) {
      if (this.waiting) {
        return false;
      }
      this.$refs[form].validateField("mobile", (valid) => {
        this.loadingCode = true;
        if (!valid) {
          this.errorMessage = null;
          const formData = new FormData();
          formData.append("mobile", this.phoneLoginForm.mobile.toString());
          sendSmsAuthCodeNew(formData)
            .then((res) => {
              this.waiting = true;
              this.value = "59s";
              this.countdown(
                59,
                () => {
                  this.value = "获取验证码";
                  this.waiting = false;
                },
                "value",
              );
              this.$message.success("验证码已发送，请注意查收");
              this.loadingCode = false;
            })
            .catch((err) => {
              if (err == "Error: 该手机号码不存在") {
                this.errorMessage = "您输入的手机号码不存在";
              }
              // this.value = '获取验证码';
              // this.waiting = false;
              this.loadingCode = false;
            });
        } else {
          this.loadingCode = false;
          return false;
        }
      });
    },

    // 获取url 信息
    queryParams(hash) {
      let params = {};
      let queryStr = hash.split("?")[1];
      if (queryStr) {
        let paramList = queryStr.split("&");
        paramList.forEach((param) => {
          params[param.split("=")[0]] = param.split("=")[1];
        });
      }
      if (params?.url) {
        setSessionStorage("loginUrl", params?.url);
      } else {
        params.url = "";
        setSessionStorage("loginUrl", "");
      }
      return params;
    },
    // 登录  接口均在 api/user/login
    submitForm(form, flag) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.loading = true;
          const formData = new FormData();
          formData.append("Password", this[form].Password);
          formData.append("LoginName", this[form].LoginName);
          if (this.urlParams?.url) {
            formData.append("url", this.urlParams.url);
          }
          if (flag) {
            // 用户密码登录
            this.$store
              .dispatch("user/loginNew", formData)
              .then((res) => {
                console.log(res, "sss");
                if (!this.automaticallyLogin) {
                  setTokenTime(Date.now());
                } else {
                  removeTokenTime();
                }
                const url = getSessionStorage("loginUrl");
                if (!!this.urlParams?.code) {
                  const code = this.urlParams.code;
                  const path = !!this.urlParams?.path
                    ? `/${this.urlParams?.path}`
                    : "";
                  if (code === "ub") {
                    this.loading = false;
                    const token = getToken();
                    if (window.location.origin?.includes("pp.gaojidata.com")) {
                      window.location = `https://ub.gaojidata.com/login?token=${token}${
                        !!path ? "&path=" + path : ""
                      }`;
                    } else {
                      window.location = `https://ub-3f3ab907.gaojidata.com/login?token=${token}${
                        !!path ? "&path=" + path : ""
                      }`;
                    }
                  } else {
                    this.$router.push({ path: "/" });
                    this.loading = false;
                  }
                } else if (url) {
                  this.loading = false;
                  const token = getToken();
                  const target = decodeURIComponent(url) + "?token=" + token;
                  // setSessionStorage('loginUrl','')
                  // removeToken()
                  window.location = target;
                } else {
                  this.$router.push({ path: "/" });
                  this.loading = false;
                }
              })
              .catch((err) => {
                console.log(err);
                this.loading = false;
              });
          } else {
            // 短信登录
            const { mobile, verifyCode } = this[form];
            let payload = {
              mobile: mobile.toString(),
              verifyCode,
            };
            if (this.urlParams?.url) {
              payload.url = this.urlParams?.url;
            }
            this.$store
              .dispatch("user/loginPhone", payload)
              .then((res) => {
                if (!this.automaticallyLogin) {
                  setTokenTime(Date.now());
                } else {
                  removeTokenTime();
                }
                const url = getSessionStorage("loginUrl");
                if (!!this.urlParams?.code) {
                  const code = this.urlParams.code;
                  const path = !!this.urlParams?.path
                    ? `/${this.urlParams?.path}`
                    : "";
                  if (code === "ub") {
                    this.loading = false;
                    const token = getToken();
                    if (window.location.origin?.includes("pp.gaojidata.com")) {
                      window.location = `https://ub.gaojidata.com/login?token=${token}${
                        !!path ? "&path=" + path : ""
                      }`;
                    } else {
                      window.location = `https://ub-3f3ab907.gaojidata.com/login?token=${token}${
                        !!path ? "&path=" + path : ""
                      }`;
                    }
                  } else {
                    this.$router.push({ path: "/" });
                    this.loading = false;
                  }
                } else if (url) {
                  this.loading = false;
                  const token = getToken();
                  const target = decodeURIComponent(url) + "?token=" + token;
                  // setSessionStorage('loginUrl','')
                  // 防止二次重登
                  // removeToken()
                  window.location = target;
                } else {
                  this.$router.push({ path: "/" });
                  this.loading = false;
                }
              })
              .catch((err) => {
                console.log(err);
                this.loading = false;
              });
          }
        } else {
          console.log("error submit!!");
          this.loading = false;
          return false;
        }
      });
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var url = location.href;
      var r = url.substr(url.indexOf("?") + 1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    changeType(type) {
      this.loginType = type;
    },
    goto_get_back_pd(route) {
      this.$router.push({ path: `/${route}` });
    },
    down_chrome() {
      if (Browser.client.type != "Chrome") {
        window.open("https://www.google.cn/chrome/");
      }

      if (Browser.client.version.split(".")[0] < 60) {
        window.open("https://www.google.cn/chrome/");
      }
    },
    other_login(type) {
      let url = null;
      if (type == "qq") {
        url = `https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=101914373&redirect_uri=${redirectUrl}/appLogin&state=qqLogin`;
      } else if (type == "wechat") {
        url = `https://open.weixin.qq.com/connect/qrconnect?appid=wxdf1270941c48d186&scope=snsapi_login&redirect_uri=${redirectUrl}/appLogin&state=weChatLogin&login_type=jssdk&self_redirect=true&styletype=&sizetype=&bgcolor=&rst=&style=black&url=${this.urlParams?.url}`;
      } else {
        url = `https://api.weibo.com/oauth2/authorize?client_id=2851333222&response_type=code&state=sinaLogin&redirect_uri=${redirectUrl}/appLogin###`;
      }
      window.location = url;
    },
    countdown(remainTime, callback, updateText) {
      let times = setTimeout(() => {
        remainTime--;
        this[updateText] = remainTime + "s";
        if (remainTime > 0) {
          this.countdown(remainTime, callback, updateText);
        } else {
          callback();
        }
        clearTimeout(times);
      }, 1000);
    },
  },
};
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

.el-form--label-top .el-form-item__label {
  line-height: 14px;
  min-height: 24px;
  min-width: 1px;
}
.el-form-item {
  margin-bottom: 25px;
}

.get-check_code {
  input {
    &:focus {
      box-shadow: none !important;
    }
    border-color: #514def;
    color: #514def;
    background-color: #ffffff;
    cursor: pointer;
    &:hover {
      color: #ffffff;
      background-color: #5f5bfb;
      border-color: #5f5bfb;
    }
    &.diabled {
      color: #c4c3ef;
      background-color: #ffffff;
      border-color: #d8d7fe;
    }
  }
  .wait {
    input,
    input:hover {
      cursor: not-allowed;
      color: #c4c3ef;
      border-color: #d8d7fe;
      background-color: #ffffff;
      width: 100px;
    }
  }
}
.config-box {
  .el-checkbox__label {
    line-height: 14px;
  }
}

.prefix-box {
  .el-input--medium .el-input__inner {
    padding-left: 58px;
  }
  span.el-input__prefix {
    i {
      font-style: normal;
      color: #343438;
      font-size: 14px;
      line-height: 16px;
      height: 16px;
      display: inline-block;
      margin-top: 14px;
      border-right: solid thin #e1e1e3;
      width: 48px;
      text-align: center;
      margin-left: -5px;
    }
  }
}
</style>

<style lang="scss" scoped>
$bg: #e1e1e1;
$dark_gray: #889aa4;
$light_gray: #eee;

.login-container {
  min-height: 768px;
  width: 100%;
  padding-top: 20px;
  overflow: hidden;
  background: url("~@/assets/images/bg_login.png") no-repeat;
  background-size: 100% auto;
  background-position: center bottom;
  background-color: #f7f7fc;
  .login-content {
    min-height: calc(100vh - 149px);
    max-width: 100%;
    width: 410px;
    position: relative;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .title-container {
      height: 68px;
      text-align: center;

      .logo {
        height: 100%;
        width: 180px;
        display: inline-block;
        transform: translateY(15px);
        //background: url('~@/assets/newLogo.png') no-repeat;
        //background-position: center center;
        //background-size: 100% auto;
      }
    }
    .login-form {
      height: 512px;
      // height: 420px;
      max-height: 100%;
      position: relative;
      padding: 41px 40px 0;
      box-shadow: 0px 5px 21px 0px rgba(81, 77, 239, 0.08);
      border-radius: 5px;
      box-sizing: border-box;
      background: #ffffff;
      margin: 60px 0 20px;
      .tabs {
        display: flex;
        margin-bottom: 27px;
        li {
          font-size: 16px;
          font-family: "Source Han Sans SC";
          color: #444444;
          margin-right: 43px;
          line-height: 14px;
          cursor: pointer;
          &.active {
            font-weight: bold;
            padding-bottom: 9px;
            border-bottom: solid 3px #514def;
          }
        }
      }
      .el-icon-invisible {
        display: inline-block;
        width: 36px;
        height: 100%;
        background: url("~@/assets/images/btn_key_invisible_normal.png")
          no-repeat;
        background-position: center;
        cursor: pointer;
        &:hover {
          background-image: url("~@/assets/images/btn_key_invisible_hover.png");
        }
        &.see {
          background-image: url("~@/assets/images/btn_key_visible_normal.png");
          &:hover {
            background-image: url("~@/assets/images/btn_key_visible_hover.png");
          }
        }
      }
      .config-box {
        display: flex;
        justify-content: space-between;
        & > span:first-child {
          display: flex;
          align-items: center;
          color: #444444;
        }
        & > span:last-child {
          color: #a4a4ad;
          cursor: pointer;
          &.get-back-pd:hover {
            color: #514def;
          }
        }
      }
      .get-check_code {
        width: 104px;
        .el-input {
          button {
            cursor: pointer;
            &:hover {
              color: #514def;
            }
          }
        }
      }
      .el-form-item__error {
        color: #f56c6c;
        font-size: 12px;
        line-height: 1;
        padding-top: 4px;
        position: absolute;
        left: initial;
        top: -10px;
        right: 0px;
        transform: translateY(-100%);
      }
      .el-button {
        width: 100%;
        margin: 12px 0 5px;
        // margin-top: 118px;
        margin-top: 3px;
        height: 42px;
        background: #514def;
        border-radius: 4px;
        font-size: 14px;
        font-family: "Source Han Sans SC";
        font-weight: 400;
        border: none;
        color: #ffffff;
      }
      .other-account {
        font-size: 12px;
        font-family: "Source Han Sans SC";
        font-weight: 400;
        color: #a4a4ad;
        text-align: center;
        .other-login {
          position: relative;
          margin-bottom: 18px;
          @mixin gapline() {
            position: absolute;
            content: "";
            display: block;
            height: 1px;
            width: calc((100% - 98px) / 2);
            background: #f0f0f2;
            top: 50%;
          }
          &::before {
            @include gapline;
            left: 0;
          }
          &::after {
            @include gapline;
            right: 0;
          }
        }
        ul {
          display: flex;
          justify-content: center;
          @mixin icon($url) {
            background: url($url) no-repeat;
            width: 32px;
            height: 32px;
            cursor: pointer;
            background-position: center top;
          }
          .icon-sina {
            position: relative;
            @include icon("~@/assets/images/btn_login_sina_normal.png");
            &::after {
              // content: "开发中";
              position: absolute;
              bottom: -23px;
              left: -4px;
              white-space: nowrap;
              color: #dadadd;
            }
            &:hover {
              @include icon("~@/assets/images/btn_login_sina_hover.png");
              &::after {
                color: #d81e06;
              }
            }
          }
          .icon-wechat {
            @include icon("~@/assets/images/btn_login_wechat_normal.png");
            &:hover {
              @include icon("~@/assets/images/btn_login_wechat_hover.png");
            }
          }
          .icon-qq {
            margin: 0 20%;
            position: relative;
            @include icon("~@/assets/images/btn_login_qq_normal.png");
            &::after {
              // content: "开发中";
              position: absolute;
              bottom: -23px;
              left: -4px;
              white-space: nowrap;
              color: #dadadd;
            }
            &:hover {
              @include icon("~@/assets/images/btn_login_qq_hover.png");
              &::after {
                color: #7bd4ef;
              }
            }
          }
        }
      }
    }
    .tips {
      margin-top: 16px;
      text-align: center;
      color: #a4a4ad;
      font-size: 14px;
      .el-icon-login-chrome {
        background: url("~@/assets/images/icon_login_chrome.png") no-repeat;
        background-position: center center;
        margin: 0 4px;
        display: inline-block;
        cursor: pointer;
        width: 14px;
        height: 14px;
      }
    }
  }

  .footer-content {
    height: 68px;
    margin-bottom: 61px;
  }

  #qq_login_btn {
    display: none;
  }
}
@media only screen and (max-width: 1366px) {
  .login-container {
    min-height: 550px;
    padding-top: 20px;
    .login-content {
      min-height: calc(100vh - 119px);
      .title-container {
        height: 67px;
      }
      .login-form {
        height: 462px;
        // height: 390px;
        padding: 30px 40px 0;
        margin: 40px 0 20px;

        .el-button {
          margin-top: 15px;
          // margin-top: 112px;
          height: 36px;
        }
        .other-account .other-login {
          margin-bottom: 8px;
        }
        .tabs {
          margin-bottom: 20px;
        }
      }
    }
    .footer-content {
      margin-bottom: 30px;
    }
  }
}
</style>
